export const getAxiosErrorMessage = (err: unknown): string => {
  // @ts-expect-error unknown
  return err?.response?.data?.message || err?.message || 'Unexpected error'
}

/** Laravel's 422 body: `{ message, errors: { 'data.definition.title': ['…'] } }`. `null` for any
 *  other failure, or a 422 whose `errors` is not that map. */
export const getAxiosValidationErrors = (err: unknown): Record<string, string[]> | null => {
  const response = (err as { response?: { status?: number, data?: { errors?: unknown } } } | null)?.response

  if (response?.status !== 422) {
    return null
  }

  const errors = response.data?.errors

  if (typeof errors !== 'object' || errors === null || Array.isArray(errors)) {
    return null
  }

  const result: Record<string, string[]> = {}

  Object.entries(errors).forEach(([key, value]) => {
    const messages = (Array.isArray(value) ? value : [value]).filter((item): item is string => typeof item === 'string')

    if (messages.length) {
      result[key] = messages
    }
  })

  return result
}
